var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencilIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 55,
    viewBox: "0 0 56 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.4368 14.897L40.6035 24.0637M44.041 36.6679L39.4577 43.5429H48.6243L44.041 50.4179M9.66602 45.8347H18.8327L42.8952 21.7722C43.4971 21.1703 43.9745 20.4557 44.3003 19.6693C44.626 18.8829 44.7937 18.04 44.7937 17.1888C44.7937 16.3376 44.626 15.4948 44.3003 14.7084C43.9745 13.922 43.4971 13.2074 42.8952 12.6055C42.2933 12.0036 41.5787 11.5262 40.7923 11.2004C40.0059 10.8747 39.1631 10.707 38.3118 10.707C37.4606 10.707 36.6178 10.8747 35.8314 11.2004C35.045 11.5262 34.3304 12.0036 33.7285 12.6055L9.66602 36.668V45.8347Z",
    stroke: "#199CB5",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencilIcon);
export default __webpack_public_path__ + "static/media/pencil-icon.87fab577eaeb9b61cfc6857c9fb22fea.svg";
export { ForwardRef as ReactComponent };